import React, { useState } from "react";

export interface HeaderProps {
  as: "h1" | "h2" | "h3" | "h4" | "h5";
  className?: string;
  children: React.ReactNode;
}
const Header: React.FC<HeaderProps> = ({ as, children, className }) => {
  switch (as) {
    case "h1":
      return (
        <h1 className={["text-3xl font-bold font-sans leading-8", className].join(" ")}>
          {children}
        </h1>
      );
    case "h2":
      return (
        <h2 className={["text-2xl font-semibold  font-sans leading-8", className].join(" ")}>
          {children}
        </h2>
      );
    case "h3":
      return (
        <h3 className={["text-xl font-semibold font-sans leading-8", className].join(" ")}>
          {children}
        </h3>
      );
    case "h4":
      return (
        <h4 className={["text-lg  font-semibold font-sans", className].join(" ")}>
          {children}
        </h4>
      );
    case "h5":
      return (
        <h5 className={["font-semibold font-sans", className].join(" ")}>
          {children}
        </h5>
      );
  }
};

export default Header;
